import type {
  CreatorFanStats,
  StatisticsData,
} from '@/modules/overview/types.ts'
import { apiClient, apiClientV2 } from '@/utils/axios.ts'
import { dateToString } from '@/utils/helpers.ts'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getStatisticsKey(creatorIds: number[], from: Date, to: Date): any[] {
  return ['statistics', { from, to }, creatorIds]
}

async function getOverview(from: Date, to: Date): Promise<StatisticsData> {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
  }

  const response = await apiClient.get(`statistics/overview`, {
    params,
  })

  return response.data
}

async function getCreatorStats(
  creatorIds: number[],
  from: Date,
  to: Date,
): Promise<StatisticsData> {
  const params = {
    creatorId: creatorIds.join(','),
    from: dateToString(from),
    to: dateToString(to),
  }
  const response = await apiClientV2.get('statistics/creator', {
    params,
  })

  return response.data
}

async function getCreatorFanStats(
  creatorId: number,
  from: Date,
  to: Date,
  page: number,
  pageSize: number,
  isDesc = true,
): Promise<CreatorFanStats[]> {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
    desc: isDesc,
    page: page,
    limit: pageSize,
  }
  const response = await apiClient.get(`statistics/creator/${creatorId}/fan`, {
    params,
  })

  return response.data
}

async function getCreatorCustomerLifetimeValue(
  creatorId: number,
  from: Date,
  to: Date,
): Promise<number> {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
  }
  const response = await apiClient.get(`statistics/creator/${creatorId}/clv`, {
    params,
  })

  return response.data
}

async function updateLinkClicks(
  creatorId: number,
  date: Date,
  linkClicks: number,
): Promise<CreatorFanStats[]> {
  const payload = {
    date: dateToString(date),
    linkClicks: linkClicks,
  }
  const response = await apiClient.post(
    `statistics/creator/${creatorId}/clicks`,
    {
      ...payload,
    },
  )

  return response.data
}

export const statisticsService = {
  getStatisticsKey,
  getOverview,
  getCreatorStats,
  getCreatorFanStats,
  getCreatorCustomerLifetimeValue,
  updateLinkClicks,
}
